import { HYDRATE } from "next-redux-wrapper";
import { ActionsSearchResult } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeSearchResult(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeSearchResult };
	case ActionsSearchResult.LOAD_GET_SEARCH_RESULT:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsSearchResult.RES_GET_SEARCH_RESULT:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsSearchResult.ERR_GET_SEARCH_RESULT:
		return {
			...state,
			data: action,
			status: "fetch_error",
			message: "Error...",
		};
	default:
		return { ...state };

	}

}

export default storeSearchResult;
